<template>
  <main>
    <h1>Cos'è Bookinsicily</h1>
    <article>
      <p>
        Bookinsicily è una piattaforma che raccoglie tutte le news presenti sul
        web che riguardano il turismo in Sicilia. Un punto di riferimento per
        chi vuole informazioni sulla Sicilia e su tutte le attività turistiche,
        enogastronomiche e culturali.<br />

        Bookinsicily offre la comodità di trovare tutto quello che riguarda il
        turismo in Sicilia in un solo posto. Bookinsicily è sempre aggiornato
        sulle ultime novità grazie all'algoritmo che raccoglie tutte le
        informazioni rilevanti presenti su Internet (compresi i social network)
        e le aggrega in home page e nelle varie voci di menù.
      </p>
      <p>
        Per parlare con noi scrivici a
        <a href="mailto:info@bookinsicily.com">info@bookinsicily.com</a>.
      </p>
    </article>
  </main>
</template>

<script>
export default {
  head() {
    return {
      title: `Cos'è Bookinsicily - Bookinsicily`,
    };
  },
};
</script>

<style lang="postcss" scoped>
@import '~/assets/vars.pcss';
@import '~/assets/media.pcss';

h1 {
  margin-bottom: $main-padding;
}

main {
  padding: $main-padding;

  @media (--medium) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

article {
  text-align: justify;

  @media (--medium) {
    padding: 0 11rem;
    text-align: center;
  }
}

.underline {
  text-decoration: underline;
}
</style>
